export default __webpack_public_path__ + "static/media/cardActivationhelp.af92b9a6.png";